import { DEFAULT_CART } from '../constants'

export function calculateProductPrices(product) {
    const sale_from = Number(product.metas?.sale_from?.value || 0),
        sale_to = Number(product.metas?.sale_to?.value || 0),
        now = Date.now()

    let price = Number(product.metas.price.value)
    let sale_price = Number(product.metas.sale_price.value)
    let hasDiscount = Boolean(
        sale_price &&
            sale_price < price &&
            ((!sale_from && !sale_to) ||
                (!sale_to && sale_from && sale_from < now) ||
                (!sale_from && sale_to && now < sale_to) ||
                (sale_from < now && now < sale_to))
    )
    let final_price = hasDiscount ? sale_price : price

    return {
        price,
        sale_price,
        final_price,
        hasDiscount
    }
}

export function calculateCartTotals(cart, products) {
    let totals = { ...DEFAULT_CART.totals }

    for (const prod of products) {
        const cartItem = cart.items.find((i) => i.variant_id === prod.id)
        if (!cartItem) {
            console.error('cant find cart item', prod, cart.items)
            throw new Error()
        }
        const qty = cartItem.qty
        const { price, final_price } = calculateProductPrices(prod)

        totals.subtotal += price * qty
        totals.items_discounts += (price - final_price) * qty
        totals.items_total += final_price * qty
        totals.total += final_price * qty
    }

    if (cart.shipping && cart.shipping.price) {
        totals.shippings_total = cart.shipping.price
        totals.total += totals.shippings_total
    }

    // console.log(totals.total, totals.shippings_total)
    // free shipping calcs
    // if (totals.total - totals.shippings_total > 350000) {
    //     console.log('ddd')
    //     totals.total -= totals.shippings_total
    //     totals.shippings_total = 0
    // }

    return totals
}
